/**
 * SSO pro Virtus Insights (dashboards de KPIs por empresa, filial e cliente).
 *
 * O Insights autentica pelo SMM: a tela /login dele aceita o access_token do SMM em `sso_token`
 * e troca por uma sessão local. Então o SSO aqui é só repassar o token atual.
 */
const INSIGHTS_BASE_URL = (
  (import.meta.env.VITE_INSIGHTS_URL as string | undefined) ||
  "https://insights.virtusautomation.com"
).replace(/\/$/, "");

/** URL de entrada com SSO (ou a home, sem sessão no SMM). Usada também pela rota /launch. */
export function getInsightsSsoUrl(): string {
  const token = localStorage.getItem("access_token");
  if (!token) return INSIGHTS_BASE_URL;
  return `${INSIGHTS_BASE_URL}/login?sso_token=${encodeURIComponent(token)}`;
}

export function openInsightsSSO(): void {
  window.open(getInsightsSsoUrl(), "_blank", "noopener,noreferrer");
}
